import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { ConfigContext } from 'src/store/ConfigContext'

export const UserContext = React.createContext({
  accountId: null,
  eligiblePrograms: [],
  selectedBizModel: null,
  selectedDeviceLocation: null,
  selectedDeviceName: null,
  selectedProgramId: null
})

const UserProvider = (props) => {
  const { sessionContext } = useContext(ConfigContext)
  const accountId = sessionContext?.tenant?.resourceId || null
  const eligiblePrograms = useMemo(
    () => sessionContext?.derivedAttributes?.eligibility || [],
    [sessionContext?.derivedAttributes?.eligibility]
  )
  const selectedBizModel = sessionContext?.user?.selectedBizModel || null
  const selectedDeviceLocation =
    sessionContext?.user?.selectedDeviceLocation || null
  const selectedDeviceName = sessionContext?.user?.selectedDeviceName || null
  const selectedProgramId = sessionContext?.user?.selectedProgramId || null

  const state = useMemo(
    () => ({
      accountId,
      eligiblePrograms,
      selectedBizModel,
      selectedDeviceLocation,
      selectedDeviceName,
      selectedProgramId
    }),
    [
      accountId,
      eligiblePrograms,
      selectedBizModel,
      selectedDeviceLocation,
      selectedDeviceName,
      selectedProgramId
    ]
  )

  return (
    <UserContext.Provider value={state}>{props.children}</UserContext.Provider>
  )
}

UserProvider.propTypes = {
  children: PropTypes.node
}

export default UserProvider
